module.exports = import("http://localhost:3000/integration_interface_esm.js");;